import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import Logo from '../../components/Logo/Logo';
import bookingsAPI from '../../services/api/bookings';
import {
  StyledButton,
  StyledButtonGroup,
  StyledContainer,
  StyledMessage,
  StyledError,
} from './TenantBookingCancellationPage.style';

const TenantBookingCancellationPage = (): JSX.Element | null => {
  const [confirmVisitStatus, setConfirmVisitStatus] = useState<number>();
  const [resText, setResText] = useState<string>('');
  const [resErrorText, setResErrorText] = useState<string>('');
  const { bookingId } = useParams();
  const { t } = useTranslation(['booking', 'misc']);

  const { status, data } = useQuery({
    queryKey: ['visit'],
    queryFn: () => bookingsAPI.getTenantBookingById(bookingId as string),
    onError(error: AxiosError) {
      setConfirmVisitStatus(error?.response?.status);
    },
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: false,
  });
  console.log('status', data?.booking.status);

  const { mutate: mutateCancel } = useMutation(
    bookingsAPI.deleteBookingBecauseOwnersSignatureExpired,
    {
      onSuccess: () => {
        setResText(t('booking:cancelSuccess'));
      },
      onError: (error: AxiosError) => {
        setResErrorText(error?.response?.data?.message);
      },
    },
  );

  return (
    <StyledContainer>
      <Logo defaultType="tenant" />
      {status === 'success' && !resText && (
        <StyledButtonGroup>
          <StyledButton
            variant="secondary"
            user="tenant"
            onClick={() =>
              mutateCancel({
                bookingId: bookingId as string,
              })
            }
          >
            {t('booking:cancelBooking')}
          </StyledButton>
        </StyledButtonGroup>
      )}
      {confirmVisitStatus === 500 && (
        <StyledError>{t('visit:wrong')}</StyledError>
      )}
      {confirmVisitStatus === 401 && (
        <StyledError>{t('visit:wrong')}</StyledError>
      )}
      {resText && <StyledMessage>{resText}</StyledMessage>}
      {resErrorText && <StyledError>{resErrorText}</StyledError>}
    </StyledContainer>
  );
};
export default TenantBookingCancellationPage;
